import { IssueTaskCategory, IssueTaskDoc, StoreIssueDoc } from '@gooduncles/gu-app-schema';

/**
 * issueTask가 금액 계산에 포함되어야 하는지 판단
 * REFUND와 ADDITIONAL_CHARGE 카테고리만 금액 계산에 포함
 */
export const shouldIncludeInAmountCalculation = (task: IssueTaskDoc): boolean => {
  return [IssueTaskCategory.REFUND, IssueTaskCategory.ADDITIONAL_CHARGE].includes(task.category);
};

/**
 * issueTask 배열의 총 금액을 계산
 * REFUND와 ADDITIONAL_CHARGE 카테고리만 계산에 포함
 */
export const calculateIssueTasksAmount = (issueTasks: IssueTaskDoc[] | undefined | null): number => {
  if (!issueTasks || issueTasks.length === 0) {
    return 0;
  }

  return issueTasks
    .filter(shouldIncludeInAmountCalculation)
    .reduce((acc, cur) => acc + (cur.amount?.totalAmount ?? 0), 0);
};

/**
 * storeIssues와 issueTasks로부터 쿼리 파라미터 문자열을 생성
 * @returns '?issue-id=xxx&task-id=yyy' 형태의 쿼리 문자열 또는 빈 문자열
 */
export const buildIssueQueryParams = (
  storeIssues: StoreIssueDoc[] | undefined | null,
  issueTasks: IssueTaskDoc[] | undefined | null
): string => {
  const storeIssueQueryParams = storeIssues ? storeIssues.map((issue) => `issue-id=${issue._id}`).join('&') : '';
  const issueTaskQueryParams = issueTasks ? issueTasks.map((task) => `task-id=${task._id}`).join('&') : '';

  return storeIssueQueryParams || issueTaskQueryParams
    ? `?${storeIssueQueryParams}${storeIssueQueryParams && issueTaskQueryParams ? '&' : ''}${issueTaskQueryParams}`
    : '';
};
